module.exports = __webpack_public_path__ + "img/04-1-1机器学习.e21e80b4.svg";